import { portalAPI } from './portalAPI';

import type { WidgetFamily, WidgetFigure } from 'types/homeWidgetFigures';
import type { CatalogueDefinition } from 'types/homeWidgets';

/** `asOf` is the day the figure is read on, in the browser's own time zone, as `yyyy-MM-dd`. */
type AsOf = { asOf: string };

/** What a widget can be built from, and the figure of one. Every answer is the caller's own. */
export const APIHomeWidgetFiguresSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        /** The families the caller may read; it can be empty. */
        getWidgetCatalogue: builder.query<WidgetFamily[], void>({
            query: () => '/v1/home-widgets/catalogue',
        }),
        getWidgetFigure: builder.query<WidgetFigure, AsOf & { id: number }>({
            query: ({ id, asOf }) => ({ url: `/v1/home-widgets/${id}/figure`, params: { asOf } }),
        }),
        /** The figure of a definition nobody stored yet. A query, so the same definition is asked for once. */
        previewWidgetFigure: builder.query<WidgetFigure, AsOf & { definition: CatalogueDefinition }>({
            query: ({ definition, asOf }) => ({
                url: '/v1/home-widgets/figure',
                method: 'POST',
                params: { asOf },
                body: definition,
            }),
            // A read sent as a POST: it must not hold, nor release, the lock a write puts on the submit buttons.
            extraOptions: { skipButtonDisable: true },
        }),
    }),
});

export const { useGetWidgetCatalogueQuery, useGetWidgetFigureQuery, usePreviewWidgetFigureQuery } =
    APIHomeWidgetFiguresSlice;
